import { CheckCircle2, MapPin, ShieldCheck } from "lucide-react";
import { SITE } from "@/config/site";
import { Seo } from "@/components/Seo";
import { Breadcrumbs, breadcrumbSchema } from "@/components/Breadcrumbs";
import { FinalCTA, SectionHeading } from "@/components/blocks";

export default function About() {
  const crumbs = [{ label: "À propos" }];
  return (
    <>
      <Seo
        title="À propos — Entreprise anti-nuisibles dans la Manche | FRELONS50"
        description="FRELONS50, entreprise locale spécialisée dans la destruction des nids de frelons et guêpes et le traitement des rongeurs dans la Manche. Une approche claire, prudente et professionnelle."
        path="/a-propos"
        jsonLd={breadcrumbSchema(crumbs)}
      />
      <section className="max-w-7xl mx-auto px-4 md:px-8 pt-8 pb-4"><Breadcrumbs items={crumbs} /></section>
      <section className="max-w-4xl mx-auto px-4 md:px-8 py-8 md:py-12">
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-brand-black leading-[1.08]">
          Un professionnel local à votre écoute
        </h1>
        <p className="mt-6 text-lg text-brand-text leading-relaxed">
          FRELONS50 est une entreprise locale spécialisée dans l'intervention contre les frelons asiatiques et européens,
          les guêpes, les rats, les souris et d'autres nuisibles dans le département de la Manche. Notre priorité :
          comprendre votre situation, vous expliquer clairement les solutions possibles et intervenir en toute sécurité.
        </p>
        <div className="mt-8 rounded-2xl overflow-hidden">
          <img src="/images/technician.webp" alt="Intervention professionnelle contre les nuisibles sur une habitation rurale de la Manche" className="w-full h-auto" width="1400" height="800" loading="lazy" />
          <p className="text-xs text-brand-text mt-2 italic">Photographie illustrative — les interventions réelles seront présentées dans une galerie dédiée.</p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 gap-4">
          {[
            ["Proximité", "Une entreprise implantée dans la Manche, qui connaît le territoire et ses habitations."],
            ["Prudence", "Nous privilégions la sécurité : aucune manipulation risquée n'est demandée au client."],
            ["Clarté", "Nous expliquons la situation et n'annonçons jamais de résultat ou de tarif non confirmé."],
            ["Réactivité", "Nous évaluons rapidement votre demande et intervenons dès que possible."],
          ].map(([t, d]) => (
            <div key={t} className="bg-brand-gray rounded-3xl p-7">
              <div className="w-10 h-10 rounded-full bg-brand-gold/15 flex items-center justify-center mb-3"><CheckCircle2 className="w-5 h-5 text-brand-gold" /></div>
              <h3 className="font-display text-lg font-bold text-brand-black">{t}</h3>
              <p className="mt-2 text-sm text-brand-text leading-relaxed">{d}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap gap-3 items-center text-sm text-brand-text">
          <span className="inline-flex items-center gap-2"><MapPin className="w-4 h-4 text-brand-gold" /> {SITE.departement}</span>
          {SITE.certibiocide.display && (
            <span className="inline-flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-brand-gold" /> {SITE.certibiocide.label}</span>
          )}
        </div>
      </section>
      <FinalCTA />
    </>
  );
}
